// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Otis Kit PRO components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

// Otis Kit PRO examples
import HorizontalTeamCard from 'examples/Cards/TeamCards/HorizontalTeamCard';

// Images
import bgImage from 'assets/images/lenguajes/Devphoto.png';
import team1 from 'assets/images/Diseño sin título (4).png';
import team2 from 'assets/images/Diseño sin título (1).png';
import team3 from 'assets/images/Diseño sin título (3).png';
import team4 from 'assets/images/Diseño sin título (2).png';

function Teamnew() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        position: 'relative',
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        padding: '80px 0',
        minHeight: '100vh',
        display: 'flex',
        placeItems: 'center',
        marginLeft: '-16px',
        marginRight: '-16px',
      }}
    >
      {/* Capa de opacidad negra */}
      <MKBox
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(30, 46, 61, 0.85)',
          zIndex: 1,
        }}
      />

      {/* Contenido encima del overlay */}
      <Container sx={{ position: 'relative', zIndex: 2 }}>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12} md={10} sx={{ mb: 9, mt: -7 }} textAlign="center">
            <MKTypography variant="h3" color="white">
              TALENTO
            </MKTypography>
            <MKTypography variant="body2" color="white" mt={1}>
              Cuentas con un equipo experimentado y especializado en diferentes áreas para
              desarrollar tus proyectos con calidad, a tiempo y dentro del presupuesto.
            </MKTypography>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Manuel Garizao"
                position={{ color: 'info', label: 'CEO' }}
                linkedin="https://www.linkedin.com/in/manuel-garizao-190607b2/"
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="David Corredor"
                position={{ color: 'info', label: 'CIO' }}
                linkedin="https://www.linkedin.com/in/david-corredor-sora/"
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Danilo Montoya"
                position={{ color: 'info', label: 'CTO' }}
                linkedin="https://www.linkedin.com/in/danilo-montoya-393040202/"
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Luz María Toro"
                position={{ color: 'info', label: 'Business Developer Leader' }}
                linkedin="https://www.linkedin.com/in/luzmatoro/"
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Teamnew;
